import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import styled from 'styled-components';
import server from 'server/serverController2';
import MainHeader from 'components/presenters/common/MainHeader';

const MainHeaderContainer = ({title}) => {
    const userInfo = useSelector((state) => {
        return state.userInfo;
    })

    const userPermission = useSelector((state) => {
        return state['userPermission'];
    })

    const [newAlarmExist, setNewAlarmExist] = useState(false);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const [cookies, setCookie] = useCookies();

    const unreadCheckCallback = (res) => {
        if(res['success'] === 0) {
            return;
        }
        const unreadMsgCount = parseInt(res['data']['count']);
        if(unreadMsgCount > 0) 
        {
            setNewAlarmExist(true);
        }
        else 
        {
            setNewAlarmExist(false);
        }
    }

    const checkShowTooltip = () => {
        const isDisableShowTooltip = cookies.disable_header_tooltip;
        if(isDisableShowTooltip) {
            return false;
        }
        return true;
    }

    const setTooltipCookies = () => {
        if(checkShowTooltip()) {
            setCookie('disable_header_tooltip', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
        }
    }

    const handleHeaderTooltip = () => {
        if(checkShowTooltip()) {
            setTooltipVisible(true);
        } else {
            setTooltipVisible(false);
        }
    }

    useEffect(() => {
        //tooltip을 보일지 말지 handling
        handleHeaderTooltip();
        
        if (userInfo['isLogin']) {
            server.getRequestData(
              `notifications/unread`,
              unreadCheckCallback,
            );
          }
    }, [])

    useEffect(() => {
        console.log(cookies);
        handleHeaderTooltip();
    }, [cookies])
    return (
        <MainHeaderBlock>
            <MainHeader 
                isLogin={userInfo['isLogin']} 
                matchingPermission={userPermission['matching']} 
                newAlarmExist={newAlarmExist} 
                title={title}
                setTooltipCookies={setTooltipCookies}
                tooltipVisible={tooltipVisible}
            />
        </MainHeaderBlock>
    );
}

const MainHeaderBlock = styled.div`
    flex: 0 1 auto;
    min-height: calc(100vw * (59.68 / 375));
    height: calc(100vw * (60 / 375));
`;

export default MainHeaderContainer;